import React, { Component } from 'react';
import moment from 'moment';
import { Button, Modal, Table } from 'semantic-ui-react';
import { get, map } from 'lodash';
import PropTypes from 'prop-types';
import AuditSearch from '../ReturnInvoices/AuditSearch';
import client from '../../apollo';
import cancelledGuaranteePurchasesAuditsQuery from '../../graphql/cancelledGuaranteePurchasesAuditsQuery';

class CancelledGuaranteePurchasesAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelledGuaranteePurchasesAudits: [],
      startDate: null,
      endDate: null,
    };
  }

  componentDidMount() {
    this.fetchCancelledGuaranteePurchasesAudit();
  }

  fetchCancelledGuaranteePurchasesAudit = () => {
    const { cancelledGuaranteePurchase } = this.props;
    const { startDate, endDate } = this.state;
    const { id } = cancelledGuaranteePurchase;
    client.query({
      query: cancelledGuaranteePurchasesAuditsQuery,
      variables: {
        cancelledPurchaseId: parseInt(id, 10),
        startDate,
        endDate,
      },
      fetchPolicy: 'network-only',
    }).then(({ data }) => {
      const cancelledGuaranteePurchasesAudits = get(data, 'cancelledPurchaseAudits');
      this.setState({
        cancelledGuaranteePurchasesAudits,
      });
    }).catch(() => {
      this.setState({
        cancelledGuaranteePurchasesAudits: [],
      });
    });
  };

  render() {
    const { isAuditModalOpen, onCloseHandler } = this.props;

    const { cancelledGuaranteePurchasesAudits, startDate, endDate } = this.state;

    const onDateChangeHandler = (field, date) => {
      this.setState({
        [field]: moment(new Date(date), 'YYYY-MM-DD'),
      });
    };

    const clearDates = () => {
      this.setState({ startDate: null, endDate: null });
    };
    return (
      <Modal
        open={isAuditModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Status History - Cancelled Guarantee Purchase</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            <div>
              <AuditSearch
                onDateChangeHandler={onDateChangeHandler}
                clearDates={clearDates}
                startDate={startDate}
                endDate={endDate}
                onSearchHandler={this.fetchCancelledGuaranteePurchasesAudit}
              />
              {map(cancelledGuaranteePurchasesAudits, audit => (
                <Table celled padded size='big' style={{ margin: '0 0' }} key={audit.id}>
                  <Table.Body>
                    <Table.Row
                      style={{ backgroundColor: 'LightGray' }}
                    >
                      <Table.Cell width={12}>
                        {audit.event === 'update'
                          && `${audit.versionAuthor} updated the Cancelled Guarantee - ${
                            audit.itemType
                          } details`}
                        {audit.event === 'create'
                          && `${audit.versionAuthor} created the Cancelled Guarantee - ${
                            audit.itemType
                          }`}
                        {audit.event === 'destroy'
                          && `${audit.versionAuthor} Destroyed Cancelled Guarantee - ${
                            audit.itemType
                          }`}
                      </Table.Cell>
                      <Table.Cell>{audit.timeStamp}</Table.Cell>
                    </Table.Row>
                    {map(JSON.parse(audit.changeset), (change, key) => {
                      if (key !== 'updated_at'
                        && audit.event === 'update'
                        && change[1] !== null
                        && change[1] !== '') {
                        return (
                          <Table.Row key={key}>
                            <Table.Cell>
                              <span>
                                set{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {key}{' '}
                                </span>
                                from{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {' '}
                                  {change[0] || 'nil'}{' '}
                                </span>
                                to{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {change[1] || 'nil'}{' '}
                                </span>
                              </span>
                            </Table.Cell>
                          </Table.Row>
                        );
                      }
                      return null;
                    })}
                  </Table.Body>
                </Table>
              ))}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

CancelledGuaranteePurchasesAudit.propTypes = {
  cancelledGuaranteePurchase: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isAuditModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
};

CancelledGuaranteePurchasesAudit.defaultProps = {
  cancelledGuaranteePurchase: {},
  isAuditModalOpen: false,
  onCloseHandler: () => {},
};

export default CancelledGuaranteePurchasesAudit;
